"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TRANSPORT_BUFFER_SIZE = void 0;
exports.createTransport = createTransport;

var _debugBuild = require("../debug-build.js");

var _envelope = require("../utils-hoist/envelope.js");

var _error = require("../utils-hoist/error.js");

var _logger = require("../utils-hoist/logger.js");

var _promisebuffer = require("../utils-hoist/promisebuffer.js");

var _ratelimit = require("../utils-hoist/ratelimit.js");

var _syncpromise = require("../utils-hoist/syncpromise.js");

const DEFAULT_TRANSPORT_BUFFER_SIZE = exports.DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */

function createTransport(options, makeRequest, buffer = (0, _promisebuffer.makePromiseBuffer)(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE)) {
  let rateLimits = {};

  const flush = timeout => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = []; // Drop rate limited items from envelope

    (0, _envelope.forEachEnvelopeItem)(envelope, (item, type) => {
      const dataCategory = (0, _envelope.envelopeItemTypeToDataCategory)(type);

      if ((0, _ratelimit.isRateLimited)(rateLimits, dataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    }); // Skip sending if envelope is empty after filtering out rate limited events

    if (filteredEnvelopeItems.length === 0) {
      return (0, _syncpromise.resolvedSyncPromise)({});
    }

    const filteredEnvelope = (0, _envelope.createEnvelope)(envelope[0], filteredEnvelopeItems); // Creates client report for each item in an envelope

    const recordEnvelopeLoss = reason => {
      (0, _envelope.forEachEnvelopeItem)(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, (0, _envelope.envelopeItemTypeToDataCategory)(type), event);
      });
    };

    const requestTask = () => makeRequest({
      body: (0, _envelope.serializeEnvelope)(filteredEnvelope)
    }).then(response => {
      // We don't want to throw on NOK responses, but we want to at least log them
      if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
        _debugBuild.DEBUG_BUILD && _logger.logger.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
      }

      rateLimits = (0, _ratelimit.updateRateLimits)(rateLimits, response);
      return response;
    }, error => {
      recordEnvelopeLoss('network_error');
      throw error;
    });

    return buffer.add(requestTask).then(result => result, error => {
      if (error instanceof _error.SentryError) {
        _debugBuild.DEBUG_BUILD && _logger.logger.error('Skipped sending event because buffer is full.');
        recordEnvelopeLoss('queue_overflow');
        return (0, _syncpromise.resolvedSyncPromise)({});
      } else {
        throw error;
      }
    });
  }

  return {
    send,
    flush
  };
}

function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }

  return Array.isArray(item) ? item[1] : undefined;
}